import { IconName } from '@lyse-as/formds-icons';
import { Component, h, Host, Prop } from '@stencil/core';

import { FdsButtonVariant } from '@/components/button/button';

@Component({
  tag: 'fds-icon-button',
  styleUrl: 'styles/icon-button.scss',
  shadow: true,
})
export class IconButton {
  /**
   * The name of the icon that should be rendered
   */
  @Prop() icon!: IconName;

  /**
   * The variant of button to render
   */
  @Prop() variant: FdsButtonVariant = 'primary';

  /**
   * If true, the button will be disabled and users cannot interact with it
   */
  @Prop() disabled = false;

  /**
   * If true, a loading indicator will be displayed inside the button instead of the button text
   */
  @Prop() isLoading = false;

  /**
   * Sets the aria-label attribute of the button
   */
  // eslint-disable-next-line @stencil-community/reserved-member-names
  @Prop() ariaLabel = this.icon as string;

  render() {
    return (
      <Host>
        <fds-button
          iconRight={this.icon}
          variant={this.variant}
          disabled={this.disabled}
          isLoading={this.isLoading}
          ariaLabel={this.ariaLabel}
        />
      </Host>
    );
  }
}
